import React from 'react'
import { graphql, useLazyLoadQuery } from 'react-relay'
import { useParams } from 'react-router-dom'

import { UserEventsPastSection } from './UserEventsPastSection'

import { UserEventsPastScreenQuery } from './__generated__/UserEventsPastScreenQuery.graphql'

export const UserEventsPastScreen = () => {
  const params = useParams()

  const data = useLazyLoadQuery<UserEventsPastScreenQuery>(
    graphql`
      query UserEventsPastScreenQuery($id: String!) {
        nodeBySlugId(id: $id) {
          __typename

          ... on User {
            ...UserEventsPastSection_user
          }
        }

        ...UserEventsPastSection_query
      }
    `,
    { id: params.actorId }
  )

  if (data.nodeBySlugId?.__typename !== 'User') {
    return null
  }

  return <UserEventsPastSection user={data.nodeBySlugId} query={data} />
}

export default UserEventsPastScreen
